import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Chip from '@material-ui/core/Chip'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import ColorPicker from './ColorPicker'
import ColorDrop from './ColorDrop'
import Fade from '@material-ui/core/Fade'
import FormHelperText from '@material-ui/core/FormHelperText'

const styles = ({ spacing: { unit } }) => ({
  root: {
    width: '100%',
    '& label + $chip': {
      marginTop: unit * 1.5,
    },
  },
  selectMenu: {
    width: 'auto',
  },
  chip: {},
  avatar: {
    boxShadow: `inset 0 0 0 1px rgba(0,0,0,0.25)`,
  },
  label: {
    flex: 1,
  }
})

class CustomColor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pickedColor: props.value,
      popperOpen: false,
    }
  }

  _updateValue = (value) => {
    const { name, onChange } = this.props
    onChange &&
      onChange({
        target: {
          type: 'color',
          name,
          value,
        },
      })
  }

  _closePopper = () => {
    this.setState({ popperOpen: false })
    this._updateValue(this.state.pickedColor)
  }

  _openPopper = (e) => {
    const { disabled } = this.props

    if (disabled) {
      return
    }

    this.setState({ popperOpen: true, anchorEl: e.currentTarget })
  }

  _onChange = ({ hex: pickedColor }) => {
    if (this.state.pickedColor === pickedColor) {
      return
    }

    this.setState({ pickedColor })
  }

  _reset = () => {
    this.setState({ pickedColor: '' })
    this._updateValue(null)
  }

  render() {
    const { classes, label, required, value: color, helperText, disabled } = this.props
    const { popperOpen, anchorEl, pickedColor } = this.state

    return (
      <FormControl required={required} className={classes.root}>
        {label && <InputLabel shrink>{label}</InputLabel>}

        <Chip
          avatar={<ColorDrop color={color} />}
          clickable={!disabled}
          label={<pre>{color && color.toUpperCase()}</pre>}
          className={classes.chip}
          classes={{label: classes.label}}
          onClick={!disabled && this._openPopper}
          onDelete={color && this._reset}
        />

        <Popper
          style={{ zIndex: 9999 }}
          placement="bottom-start"
          transition
          open={popperOpen}
          anchorEl={anchorEl}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={this._closePopper}>
              <Fade {...TransitionProps} timeout={150}>
                <Paper>
                  <ColorPicker
                    disableAlpha
                    color={pickedColor}
                    onChange={this._onChange}
                    presetColors={[{ color: 'transparent', title: 'Transparent' }]}
                    />
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    )
  }
}

export default withStyles(styles)(CustomColor)
